import React, { useRef } from "react";
import styles from "./work.module.scss";
import { motion, useScroll, useTransform } from "framer-motion";
import { useCursor } from "../../utils/useCursor";
import { width } from "@mui/system";
import { Link } from "react-router-dom";

const Card = ({
  index,
  color,
  title,
  link,
  desc,
  img,
  progress,
  targetScale,
  range,
  tech1,
}) => {
  const { setCss, setText, initialCss } = useCursor();
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start end", "start start"],
  });
  const imageScale = useTransform(scrollYProgress, [0, 1], [2, 1]);
  const scale = useTransform(progress, range, [1, targetScale]);

  return (
    <motion.div
      ref={container}
      className={styles.cardContainer}
      style={{
        top: `calc(-10% + ${index * 25}px)`,
        scale: scale,
        cursor: "none",
      }}
    >
      <div
        onMouseEnter={() => {
          setCss({
            height: 64,
            width: 64,
            background: color,
          });
          setText("View");
        }}
        onMouseLeave={() => {
          setCss(initialCss);
          setText("");
        }}
        style={{
          background: color,
        }}
        className={`${styles.card} w-full sm:w-[60%] h-3/4 md:h-[500px] lg:h-[400px]`}
      >
        <Link to={link} target="_blank" className="cursor-none">
          <div className="flex flex-col gap-2 h-full">
            <h1 className="text-white w-full text-2xl font-semibold text-center">
              {title}
            </h1>

            <div className="flex w-full gap-3 pt-4 h-full lg:flex-row flex-col-reverse">
              <div className="flex lg:w-[40%] flex-col">
                <p className={`${styles.desc} w-full text-sm`}>{desc}</p>
                <p className="tech text-white lg:pt-3">{tech1}</p>
              </div>

              <div className={`${styles.imageContainer} w-full lg:w-[60%]`}>
                <motion.div
                  style={{ scale: imageScale }}
                  className={styles.inner}
                >
                  <img src={img} className="object-cover" />
                </motion.div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </motion.div>
  );
};

export default Card;
